import { styled, Table as MuiTable } from "@mui/material";
import {
  SIDE_BAR_OPEN_WIDTH,
  APP_BAR_HEIGHT
} from "../../../../../configurations/appConstants";

const PREFIX = "ActionTableStyle";
export const classes = {
  table: `${PREFIX}-table`
};

export const Table = styled(MuiTable)(({ theme }) => ({
  [`&.${classes.table}`]: {
    minWidth: theme.typography.pxToRem(window.innerWidth - SIDE_BAR_OPEN_WIDTH),
    marginTop: theme.typography.pxToRem(theme.spacing(3)),
    overflowX: "auto"
  }
}));
